import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';

/** Rótulo de conexão persistido (mesma regra da listagem de controladores). */
export function rotuloStatusConexao(c) {
  if (!c) return { label: '—', online: null, css: '' };

  const ativo = c.ativo != null ? Number(c.ativo) : null;
  if (ativo === -1) return { label: 'Offline', online: false, css: 'is-offline' };

  const monitora = parseInt(c.monitora_erro, 10);
  if (monitora === 0) return { label: 'Indeterminado', online: null, css: 'is-neutro' };

  const st = parseInt(c.status_conexao, 10);
  if (Number.isNaN(st)) return { label: '—', online: null, css: '' };

  if (st <= 1) return { label: 'Conectado', online: true, css: 'is-online' };
  return { label: 'Sem conexão', online: false, css: 'is-offline' };
}

/** true = conectado (status_conexao no banco); false = sem conexão / offline / indeterminado. */
export function controladorConectadoNoCadastro(c) {
  return rotuloStatusConexao(c).online === true;
}

/** Quantidade de anéis; parênteses só quando há mais de um anel cadastrado. */
export function textoAneisControlador(c) {
  const qtd = c && c.qtd_aneis != null ? Number(c.qtd_aneis) : null;
  if (qtd == null || qtd <= 0) return null;
  if (qtd === 1) return '1';

  const lista = c.aneis_lista && String(c.aneis_lista).trim();
  return lista ? `${qtd} (${lista})` : String(qtd);
}

export function podeResetarControlador(c) {
  return !!(c && c.ip && c.porta != null && c.porta !== '' && c.numero_controlador != null);
}

export function resetarControladorRemoto(c) {
  const ip = c.ip || '';
  const porta = c.porta != null ? c.porta : '';
  const num = c.numero_controlador;
  return axiosInstance.get(`/controladores/reset/${ip}/${porta}/${num}`);
}

export function executarResetControlador(c) {
  if (!podeResetarControlador(c)) {
    toastr.warning('Reset', 'IP, porta ou número do controlador não informados.');
    return Promise.resolve(false);
  }
  return resetarControladorRemoto(c)
    .then(resp => {
      toastr.success('Sucesso!', resp.data);
      return true;
    })
    .catch(() => {
      toastr.error('Erro', 'Sem conexão. O número ou endereço do controlador podem estar errados.');
      return false;
    });
}
